import React, { FC } from 'react';
import { DrivingReportList } from './DrivingReportList/DrivingReportList';

export const DrivingReportListPage: FC = () => {
  return <DrivingReportList />;
};
